import React from 'react'
import { Outlet } from 'react-router-dom'

import { AppRefreshProvider } from 'context/AppRefreshContext'
import theme from 'theme'

export const UnauthenticatedRoutesWrapper: React.FC = () => {
  return (
    <AppRefreshProvider>
      <div
        css={{
          backgroundColor: theme.colors.gray[0],
          position: 'relative'
        }}
      >
        <Outlet />
      </div>
    </AppRefreshProvider>
  )
}
